import { TextChannelKey } from 'types'
import Styles from './ListItemContainer.module.scss'
import { AspectRatioKey } from 'components/NewFileModal/Types'
import { WizardsProps } from 'components/Wizards/Types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { NewDesignListItem, NewDocListItem, WizardListItem } from '../ListItem/ListItem'
import { Text } from 'blaze-ui/Text/Text'

export interface ListItemContainerProps {
  children: React.ReactNode
}

export const ListItemContainer = ({ children }: ListItemContainerProps) => {
  return (
    <div className={Styles.itemsList}>
      <div className={Styles.section}>{children}</div>
    </div>
  )
}

export interface WizardListItemContainerProps {
  heading?: string
  subHeading?: string
  wizards: Array<TextChannelKey | AspectRatioKey>
  initialValues: WizardsProps['initialValues']
  onSuccess: WizardsProps['onSuccess']
  withDoc?: boolean
  withDesign?: boolean
  children?: React.ReactNode
}
export const WizardListItemContainer = ({
  heading,
  subHeading,
  wizards,
  withDoc,
  withDesign,
  children,
  ...props
}: WizardListItemContainerProps) => {
  return (
    <>
      <div className={Styles.header}>
        {heading && <Heading level={5}>{heading}</Heading>}
        {subHeading && (
          <Text variant="placeholder" color="var(--Dark-60, rgba(0, 0, 0, 0.60))">
            {subHeading}
          </Text>
        )}
      </div>
      <ListItemContainer>
        {wizards.map((channel) => (
          <WizardListItem key={channel} channelKey={channel} {...props} />
        ))}
        {withDoc && <NewDocListItem />}
        {withDesign && <NewDesignListItem />}
        {children}
      </ListItemContainer>
    </>
  )
}
